export class ColumnStyle {
  verticalAlignment = '';
  background = '';
  paddingLeft = '';
  paddingRight = '';
  paddingTop = '';
  paddingBottom = '';
  imageSize = 'uk-background-cover';
  imagePosition = 'uk-background-center-center';
  imageEffect = '';
  imageParallaxValues = [0, 0, 0, 0];
  imageBreakpoint = '';

  static normalize(styles: Partial<ColumnStyle>): ColumnStyle {
    const pureStyles = new ColumnStyle();

    pureStyles.verticalAlignment = styles.verticalAlignment ?? pureStyles.verticalAlignment;
    pureStyles.background = styles.background ?? pureStyles.background;
    pureStyles.paddingLeft = styles.paddingLeft ?? pureStyles.paddingLeft;
    pureStyles.paddingRight = styles.paddingRight ?? pureStyles.paddingRight;
    pureStyles.paddingTop = styles.paddingTop ?? pureStyles.paddingTop;
    pureStyles.paddingBottom = styles.paddingBottom ?? pureStyles.paddingBottom;
    pureStyles.imageSize = styles.imageSize ?? pureStyles.imageSize;
    pureStyles.imagePosition = styles.imagePosition ?? pureStyles.imagePosition;
    pureStyles.imageEffect = styles.imageEffect ?? pureStyles.imageEffect;
    pureStyles.imageParallaxValues = styles.imageParallaxValues ?? pureStyles.imageParallaxValues;
    pureStyles.imageBreakpoint = styles.imageBreakpoint ?? pureStyles.imageBreakpoint;

    return pureStyles;
  }
}
